import React from 'react';

const SwapConfirmationModal = ({ onConfirm, onCancel }) => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50'>
      <div className='bg-white p-6 rounded-lg max-w-sm w-full'>
        <h3 className='text-lg font-bold mb-4'>Swap Return Gift</h3>
        <p className='mb-6'>
          A return gift is already in your cart. Would you like to swap it for
          the new one?
        </p>
        <div className='flex justify-end space-x-4'>
          <button
            onClick={onCancel}
            className='px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 transition-colors'
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className='px-4 py-2 rounded bg-buttonprimary text-white transition-colors'
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default SwapConfirmationModal;
